module.exports = __webpack_public_path__ + "img/logo.a5a3ff32.png";